<div>
  <h5 mat-dialog-title>{{ 'updateCompany' | translate }}</h5>
  <form [formGroup]="formGroup" fxLayout="column">

    <!-- Categories -->
    <mat-form-field color="accent">
      <mat-label>{{ 'categories' | translate }}</mat-label>
      <mat-select formControlName="categories" multiple>
        <mat-option *ngFor="let category of (categories$ | async)?.data" [value]="category.id">
          {{category.nameTranslations[currentLanguage]}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Email -->
    <mat-form-field color="accent">
      <mat-label>{{ 'email' | translate }}</mat-label>
      <input matInput formControlName="email">
      <mat-error *ngIf="hasError('email', 'required')">
        {{ 'requiredError' | translate }}
      </mat-error>
      <mat-error *ngIf="hasError('email', 'maxlength')">
        {{ 'maxLengthError' | translate:{ value: 254 } }}
      </mat-error>
      <mat-error *ngIf="hasError('email', 'email')">
        {{ 'emailNotValid' | translate }}
      </mat-error>
    </mat-form-field>

    <!-- Phone -->
    <mat-form-field color="accent">
      <mat-label>{{ 'phone' | translate }}</mat-label>
      <input matInput formControlName="phone">
      <mat-error *ngIf="hasError('phone', 'required')">
        {{ 'requiredError' | translate }}
      </mat-error>
      <mat-error *ngIf="hasError('phone', 'maxlength')">
        {{ 'maxLengthError' | translate:{ value: 20 } }}
      </mat-error>
      <mat-error *ngIf="hasError('phone', 'pattern')">
        {{ 'phoneNotValid' | translate }}
      </mat-error>
    </mat-form-field>

    <!-- Website -->
    <mat-form-field color="accent">
      <mat-label>{{ 'website' | translate }}</mat-label>
      <input matInput formControlName="website">
      <mat-error *ngIf="hasError('website', 'required')">
        {{ 'requiredError' | translate }}
      </mat-error>
      <mat-error *ngIf="hasError('website', 'pattern')">
        {{ 'websiteNotValid' | translate }}
      </mat-error>
    </mat-form-field>

    <!-- AgentURL -->
    <mat-form-field color="accent">
      <mat-label>{{ 'agentUrl' | translate }}</mat-label>
      <input matInput formControlName="agentUrl">
      <mat-error *ngIf="hasError('agentUrl', 'required')">
        {{ 'requiredError' | translate }}
      </mat-error>
      <mat-error *ngIf="hasError('agentUrl', 'pattern')">
        {{ 'agentUrlNotValid' | translate }}
      </mat-error>
    </mat-form-field>

    <!-- Name translations -->
    <div formGroupName="nameTranslations">
      <span>{{ 'nameTranslations' | translate }}</span>
      <div *ngFor="let language of languages" fxLayout="column">
        <mat-form-field color="accent">
          <mat-label>{{ language.code }}</mat-label>
          <input matInput [formControlName]="language.id">
          <mat-error>
            {{ 'requiredError' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>

  <!-- Actions -->
  <div mat-dialog-actions fxLayoutAlign="end">
    <button mat-button (click)="onCancel()">{{ 'cancel' | translate }}</button>
    <button mat-raised-button (click)="onSave()" color="accent">{{ 'save' | translate }}</button>
  </div>
</div>
